<template lang="pug">
    .contentpage(v-if="restriction === null || restriction === '' || isAllowed")
        .header-area(v-if="areas.header && areas.header.length")
            section(v-for="(section, index) in areas.header" :key="section.id" :class="section.key")
                Banner(v-if="section.key === 'banner'" :section="section")
                Slider(v-if="section.key === 'slider'" :section="section")
        .main-area(v-if="areas.main && areas.main.length")
            h1.visually-hidden DIVƎRGANCY MODELS - {{ $route.fullPath.replace(/^\//, "") }}
            section(v-for="(section, index) in areas.main" :key="section.id" :class="section.key")
                Heading(
                    v-if="section.key === 'heading'" 
                    :section="section"
                    heading-class="is-size-2-desktop is-size-3-tablet is-size-4-mobile"
                    sub-heading-class="is-size-6 is-uppercase has-text-primary"
                )
                CategoryPosts(
                    v-if="section.key === 'categoryposts'"
                    :section="section"
                    :per-page="12"
                    orientation="horizontal"
                )
                ImageSection(v-if="section.key === 'image'" :section="section")
                Post(v-if="section.key === 'post'" :section="section")
                PhotoAlbum(v-if="section.key === 'photoalbum'" :section="section")
                Card(v-if="section.key === 'card'" :section="section")
                Video(v-if="section.key === 'video'" :section="section")
                Form(v-if="section.key === 'form'" :section="section")
                LoginForm(v-if="section.key === 'login' && !isAuthenticated" :section="section")
        .footer-area(v-if="areas.footer && areas.footer.length")
            section(v-for="(section, index) in areas.footer" :key="section.id" :class="section.key" v-if="index === 0")
                Post(v-if="section.key === 'post'" :section="section")
    .contentpage(v-else)
        .header-area(v-if="areas.header && areas.header.length")
            section(v-for="(section, index) in areas.header" :key="section.id" :class="section.key" v-if="index === 0")
                Banner(v-if="section.key === 'banner'" :section="section")
        .main-area(v-if="areas.main && areas.main.length")
            section
                h2.loginInfo Dieser Bereich ist nur für eingeloggte Benutzer zugänglich!
            section(v-for="(section, index) in areas.main" :key="section.id" :class="section.key")
                LoginForm(v-if="section.key === 'login'" :section="section")
        .footer-area(v-if="areas.footer && areas.footer.length")
            section(v-for="(section, index) in areas.footer" :key="section.id" :class="section.key" v-if="index === 0")
                Post(v-if="section.key === 'post'" :section="section")
</template>

<script>

// import _ from 'lodash'
import { mapGetters } from 'vuex'

import Heading from '@/components/Heading'
import ImageSection from '@/components/ImageSection'
import CategoryPosts from '@/components/CategoryPosts'
import Post from '@/components/Post'
import Banner from '@/components/Banner'
import PhotoAlbum from '@/components/PhotoAlbum'
import Card from '@/components/Card'
import Video from '@/components/Video'
import Form from '@/components/Form'
import LoginForm from '@/extensions/restricted-area/components/LoginForm';
import Slider from '@/components/Slider'

export default {
    name: 'ContentPage',
    components: {
        Heading,
        ImageSection,
        CategoryPosts,
        Post,
        Banner,
        Card,
        Video,
        Form,
        PhotoAlbum,
        LoginForm,
        Slider
    },
    computed: {
        areas() {
            let areas = {};
            this.sections.map( section => {
                const key = section.area || 'main';
                if ( !areas[key] ) areas[key] = [];
                areas[key].push(section)
            } );
            return areas;
        },
        isAllowed() {
            let result = true;

            if (this.restriction !== null || this.restriction !== '') {
                if ((this.restriction === 'members' && !this.isAuthenticated) || (this.restriction === 'guests' && this.isAuthenticated)) {
                    result = false;
                }
            }

            return result;
        },
        ...mapGetters({
            sections: 'currentPage/sections',
            restriction: 'currentPage/restriction',
            isAuthenticated: 'auth/isAuthenticated'}
        )
    }
}

</script>

<style lang="sass" scoped>
    @import '~@/assets/sass/variables'
    .visually-hidden
        position: absolute
        width: 1px
        height: 1px
        padding: 0
        margin: -1px
        overflow: hidden
        clip: rect(0 0 0 0)
        white-space: nowrap
        border: 0
    .loginInfo
        text-align: center
    .card
        box-shadow: none
    section
        margin-top: 25px 
    .section.slider,
    .section.banner, .section.videostreaming
        padding: 0
    .section.heading
        padding-bottom: 0
    .footer-area
        background-color: #2f2f2f
        //position: absolute
        width: 100%
        bottom: 0
        padding: 75px 0
        &::v-deep .post 
            color: #fff!important
    .header-area, .main-area
        margin-bottom: 35px
    .main-filter
        text-align: center
        font-size: 24px
        a
            color: #000
            margin: 0 25px
            &:hover
                color: $primary
                text-decoration: underline
    .subfilter
        margin: 15px auto
        padding: 25px 0
        border-top: 3px solid $primary
        border-bottom: 3px solid $primary
        display: flex
        flex-direction: row
        justify-content: space-between
        input
            padding: 0 15px
</style>
